<template>
  <div class="animated fadeIn list-of-book">
    <b-card>
      <div slot="header">GL Journal - Dimension Revision
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuDimShow=true"><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Journal Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.nomor" placeholder="nomor (% for wildcard)"></b-form-input>
              <b-input-group-prepend><span class="pt-2">Group &nbsp;</span></b-input-group-prepend>
              <b-form-select v-model="tblData.kodejurnal" :plain="true" :options="jurnalGroup"></b-form-select>
            </b-input-group>
            <!-- <b-input-group >
                <b-input-group-prepend><label>GL Account</label></b-input-group-prepend>
                <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
                <b-form-input v-model="tblData.namaacc" placeholder="Account Name" class="ml-1" style="width:30% !important"></b-form-input>                
            </b-input-group> -->
            <b-input-group >
                <b-input-group-prepend><label>GL Account</label></b-input-group-prepend>
                        <b-form-input  v-model="tblData.kodeacc" placeholder="Account Code" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('kodeacc')">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                            <b-form-input  v-model="tblData.namaacc" placeholder="Account Code"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCoa('namaacc')">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Reference</label></b-input-group-prepend>
              <b-form-input v-model="tblData.reff" placeholder="Reference(% wildcard)"></b-form-input>
                <b-input-group-append> <b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
                <b-input-group-append> <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        v-model="items" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"        
       @row-clicked="rowClicked"
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print JV</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(kodeacc)="data"> 
          <span v-if="(data.item.judul=='Y') || (!data.item.namaacc)" style="color:red;"> {{data.item.kodeacc}} | {{data.item.namaacc}} </span>
          <span v-else> {{data.item.kodeacc}} | {{data.item.namaacc}} </span>
        </template>
        <template v-slot:cell(umasuk)="data">
          {{data.item.umasuk|numFormat}}
        </template>
        <template v-slot:cell(ukeluar)="data">
          {{data.item.ukeluar|numFormat}}
        </template>
        <template v-slot:cell(Dim1)="data">
          <b-link @click="edit(data.item,'Dim1')">
              <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
              <span v-else><i class="fa fa-pencil"></i></span>
          </b-link>
        </template>
        <template v-slot:cell(Dim2)="data">
          <b-link @click="edit(data.item,'Dim2')">
              <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
              <span v-else><i class="fa fa-pencil"></i></span>
          </b-link>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right" vif="pagination" 
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuDimShow" size="lg" :hide-footer="true" title="List of Dimension Value" :centered="true" >
        <lku-dim @click="onSelectedDim" :DimColName="tblData.DimCol" :key="tblData.DimCol"></lku-dim>
    </b-modal>        
    <b-modal v-model="lkuDimShow2" size="lg" :hide-footer="true" title="Change Dimension Value" :centered="true" >
        <lku-dimlazzy @click="onSelectedDim2" :DimColName="DimColEdited" :lkudata="lkuDimData" :key="DimColEdited"></lku-dimlazzy>
    </b-modal>        

        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun" :allowHeader="true"></lku-coa>
        </b-modal>        

  </div>
</template>

<style lang="scss">
  .list-of-book {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
   }
</style>


<script>
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuCoa from "../lookup/lkuCoa";
import buku from "../../apis/buku";
import lkuDim from "../lookup/lkuDim";
import lkuDimlazzy from "../lookup/lkuDimLazzy";
toastr.init();
export default {
  data() {
    return {
      lkuDimShow:false,
      lkuDimShow2:false,
      lkuDimData:{},
      showDelConfirm: false,
      lkuCoaShow:false,
      lkuCoaCaller:'',
      tahun:moment(this.$store.state.user.tglaktif).format('YYYY'),
      horizontal: true,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      items: [],
      pagination:false,
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: 'nomor',
        sortDesc: false,
        DimCol:'Dim1', kodejurnal:''
      },
      limit:20,
      DimColEdited:'Dim1',
      jurnalGroup:[{ value: '', text: '-- All Source -' }, 
              { value: 'AP%', text: '-- AP Related --' },
              { value: 'AR%', text: '-- AR Related --' },
              { value: '%ADV%', text: '-- ADVANCE Related --' },
              { value: '%JV%', text: '-- JV Manual --' },
              { value: 'BANK%', text: '-- Bank --' },
              { value: 'INV%', text: '-- Inventory --' },
          ]      
    };
  },
  components: {Loading, lkuCoa, lkuDim, lkuDimlazzy},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "nomor",
            label: "JV Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "JV Date",
            sortable: true
          },
          {
            key: "kodeacc",
            label: "Account",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "reff",
            label: "Reference",
          },
          {
            key: "umasuk",
            label: "Debit",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ukeluar",
            label: "Credit",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          }
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: dims[i].value,
            // thStyle: "width:150px",
            label: dims[i].text,
            sortable: true
          },)
        }

      return fields;
    }
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
      dimCol: function(newval) {
          this.tblData.DimVal="";
          this.tblData.DimValInfo="";
          this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
      },
  },
  created: async function(){
      const kodeList = await buku.kodejurnal();
      this.jurnalGroup = kodeList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },this.jurnalGroup);
  },    
  methods: {
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller==='kodeacc'){
            this.tblData.kodeacc = _selected.kodeacc;
        } else {
            this.tblData.namaacc = _selected.kodeacc;
        }
        this.lkuCoaShow=false;
    },
    onSelectedDim: function(_selected){
        this.tblData.DimVal=_selected.nama;
        this.tblData.DimValCode=_selected.kode;
        this.tblData.DimValInfo=`${_selected.kode.trim()} | ${_selected.nama}`;
        this.lkuDimShow=false;
    },   
    onSelectedDim2: function(lkuData){
        this.lkuDimData=lkuData;
        this.model[this.DimColEdited]=lkuData.selected.kode;
        this.model[`${this.DimColEdited}Txt`]=lkuData.selected.nama;
        this.model[`${this.DimColEdited}Info`]=`${lkuData.selected.kode.trim()} | ${lkuData.selected.nama}`;
        this.lkuDimShow2=false;
        try {
            const obj={
                  bukukey: this.model.bukukey, 
                  TableKey: this.model.DimTableKey || this.model.bukukey,
                  DimCol: this.DimColEdited,                  
            };
            obj[this.DimColEdited]=lkuData.selected.kode;
            obj[`${this.DimColEdited}Txt`]=lkuData.selected.nama;
            buku.changeDimension(obj).then(result => {
                    console.log('changeDimension -> ', result);
                })
                .catch(err => {
                    console.log('changeDimension error ', err);
                    if (err.sql) {
                        toastr.error(err.sql,'ERROR MESSAGE',10000);
                    } else if (err.sqlMessage) {
                        toastr.error(err.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (err.message) {
                        toastr.error(err.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(err),'ERROR MESSAGE',10000);
                    }   
                });
        } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }

    },   
    edit: function(data,DimCol) {
            // if (this.model) this.model.selected = 0;
            this.model=data;
            // this.model.selected = 1;
            this.DimColEdited=DimCol;
            this.lkuDimShow2=true;
    },       
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
      this.pagination=false;
          const filter = this.$store.state.filter;
          let filtered=false;
          for (var key in filter.bukujvlist) {
              this.tblData[key] = filter.bukujvlist[key];
              filtered=true;
          }
          if (filtered === true) {
            this.tblData.tgl1=filter.bukujvlist.tgl1 || '';
            this.tblData.tgl2=filter.bukujvlist.tgl2 || '';
            this.showFilter=filtered;
            delete filter.bukujvlist;
            this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                // this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
                  const list = await buku.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                // this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
                  const list = await buku.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.kodejurnal=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.DimValCode=  '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];
      let filtered = false;
      const bukujvlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              bukujvlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          bukujvlist.page=this.tblData.page;
          bukujvlist.limit=this.tblData.limit;
          bukujvlist.sortBy=this.tblData.sortBy;
          bukujvlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.bukujvlist=bukujvlist;
          this.$store.commit("filter", filter);
      }
    },    
    rowPrint(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    
    exportxls: async function() {
        this.isLoading=true;
        try {
            response = await buku.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log(error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },
    printjv: async function()
    {
       if (this.model) {
          try {              this.showReport=true;

              this.reportUrl= await buku.printjv({ nomor: this.model.nomor, tanggal:moment(this.model.tanggal).format('YYYY-MM-DD'), kodejurnal: this.model.kodejurnal});

          } catch (error) {
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
          }
        } else {
          toastr.warn('Please select one Data taht want to print ');
        }
    },    close(){
      router.push("home");
    },    

  }
};
</script>
